import { render, staticRenderFns } from "./RemarksListView.vue?vue&type=template&id=14cab9c5"
import script from "./RemarksListView.vue?vue&type=script&lang=js"
export * from "./RemarksListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports